export default __webpack_public_path__ + "static/media/guidelines-5.4f305828.jpeg";